import { gql } from "@apollo/client";
import { empType } from "../../../../../utils/Enum.types";
import { userDetails } from "../../../../../utils/commonQueryTypes";

export const AddEmpMaster = gql`
  mutation AddEmpMaster(
    $token: String!
    $input: CreateEmpMasterInput!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddEmpMaster(
      token: $token
      input: $input
      customer_id: $customer_id
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const UpdateEmpMaster = gql`
  mutation UpdateEmpMaster(
    $token: String!
    $emp_id: ID!
    $customer_id: ID!
    $input: UpdateEmpMasterInput!
    $user_details: SubscribedUser!
  ) {
    UpdateEmpMaster(
      token: $token
      input: $input
      emp_id: $emp_id
      customer_id: $customer_id
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const ImportEmp = gql`
  mutation ImportEmp(
    $token: String!
    $customerID: ID!
    $input: ImportEmpData!
    $user_details: SubscribedUser!
  ) {
    ImportEmp(
      token: $token
      customerID: $customerID
      input: $input
      user_details: $user_details
    )
  }
`;
